import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue'
  import useCommonMixin from '@/composables/useCommonMixin'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneNumberInput',
  props: {
    phoneNumber: {
      type: String,
      default: '',
    },
  },
  emits: ['phone-input'],
  setup(__props, { emit }) {

const props = __props;

  const { getColorVariableValue } = useCommonMixin()

  
  
  const phoneInput = ref({ formatInternational: '', countryCode: '', isValid: false })
  const initialPhoneNumber = ref(props.phoneNumber)

  const translations = {
    countrySelectorLabel: '',
    countrySelectorError: 'Wähle ein Land',
    phoneNumberLabel: 'Telefonnummer',
  }

  const validColor = computed(() => getColorVariableValue.value('--primary-color'))

  watch(phoneInput, (value) => {
    if (value.formatInternational && value.isValid) {
      emit('phone-input', value.formatInternational)
    } else {
      emit('phone-input', '')
    }
  })

return { __sfc: true,getColorVariableValue, props, emit, phoneInput, initialPhoneNumber, translations, validColor, computed, ref, watch, useCommonMixin }
}

})